import React from 'react';
import Version1223 from './version12-23';
import Version521 from './version5-21';

function GeorgiaForm(props) {
  const { version } = props;

  switch (version) {
    case '5_21':
      return <Version521 {...props} />;
    case '12_23':
      return <Version1223 lineHDivisor={3000} {...props} />;
    default:
      return <Version1223 lineHDivisor={4000} {...props} />;
  }
}

export default GeorgiaForm;
